import List from './list'
import ProjectDetail from './detail'

const ProjectList = List
export {
    ProjectList,
    ProjectDetail
}
